import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createGitBranch } from '@/services/git/api';
import type { CreateGitBranchInput, GitBranch } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useCreateGitBranch(): UseMutationResult<GitBranch, Error, CreateGitBranchInput> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: (input: CreateGitBranchInput) => createGitBranch(orgId!, input),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['gitBranches', orgId, vars.repo_full_name] });
      queryClient.invalidateQueries({ queryKey: ['defaultGitBranch', orgId] });
    },
  });
}
